import React from 'react';
import PropTypes from 'prop-types';

import { Rating } from 'react-simple-star-rating';

import starIcon from 'images/new_ui/icons/star-2.svg';
import starFilledIcon from 'images/new_ui/icons/star-filled-2.svg';

export default function Preview({ rate }) {
  return (
    <Rating
      initialValue={rate}
      readonly
      emptyIcon={<img src={starIcon} alt="star" />}
      fillIcon={<img src={starFilledIcon} alt="star" />}
    />
  );
}

Preview.propTypes = {
  rate: PropTypes.number,
};

Preview.defaultProps = {
  rate: 0,
};
